import { List, Record } from 'immutable';
import { Adjustment } from '../../event/models/adjustment';
import { OnyxEvent } from '../../event/models/event';
import { Payment } from '../../event/models/payment';

const PaymentRequestRecord = Record({
  event: null,
  roomCommissions: null,
  adjustments: null,
  finalPayment: null,
  prepayment: null,
  approverType: null,
  estimatedTax: null,
  fundCurrency: null
});

export class PaymentRequest extends PaymentRequestRecord {
  event: OnyxEvent;
  roomCommissions: number;
  adjustments: List<Adjustment>;
  finalPayment: Payment;
  prepayment: Payment;
  approverType: String;
  estimatedTax: number;
  fundCurrency: String;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/model/payment-request.ts